import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/useReveal";

export default function FinalCTA() {
    return (
        <section
            id="cta"
            data-testid="cta-section"
            className="relative pt-28 sm:pt-36 pb-32"
        >
            {/* ambient glow */}
            <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[600px] w-[900px] max-w-[95vw] rounded-full opacity-70 anim-pulse-glow"
                 style={{ background: "radial-gradient(closest-side, rgba(139,92,246,0.3), rgba(139,92,246,0.05) 60%, transparent 75%)" }}
            />

            <div className="relative mx-auto max-w-4xl px-6 text-center">
                <div className="reveal relative inline-flex items-center justify-center">
                    <div className="absolute inset-0 rounded-full anim-pulse-glow"
                         style={{ background: "radial-gradient(closest-side, rgba(139,92,246,0.5), transparent 70%)" }}
                    />
                    <img
                        src={LOGO_URL}
                        data-testid="cta-logo"
                        alt="CEO's GPT"
                        className="logo-blend relative h-[154px] w-[154px] sm:h-48 sm:w-48 object-contain anim-float-slow"
                        style={{
                            filter: "drop-shadow(0 20px 50px rgba(139,92,246,0.4))",
                        }}
                    />
                </div>

                <h2 className="reveal mt-10 font-display text-4xl sm:text-5xl lg:text-[64px] leading-[1.03] tracking-tight font-light text-black">
                    Stop managing reports.
                    <br />
                    <span className="italic font-normal">
                        Start commanding decisions.
                    </span>
                </h2>
                <p className="reveal mt-6 text-[15px] sm:text-lg text-neutral-600 leading-relaxed max-w-2xl mx-auto">
                    CEO’s GPT turns your business into one intelligent
                    conversation where every insight becomes an action.
                </p>

                <div className="reveal mt-10 flex items-center justify-center">
                    <Link
                        to="/demo"
                        data-testid="cta-button"
                        className="group inline-flex items-center gap-2 bg-black text-white text-sm font-medium pl-6 pr-2 py-2 rounded-full hover:shadow-[0_25px_60px_-15px_rgba(139,92,246,0.7)] transition-all"
                    >
                        <span className="py-1.5 inline-flex items-center gap-2">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M8 5v14l11-7z" fill="currentColor" /></svg>
                            Demo as CEO of EVOLVE
                        </span>
                        <span className="ml-1 inline-flex items-center justify-center h-9 w-9 rounded-full bg-white text-black transition-transform group-hover:translate-x-0.5">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                    </Link>
                </div>
            </div>
        </section>
    );
}
